/**
 * Custom hook for fetching and managing company/domain information
 * Customize according to your backend API structure
 */
import { useState, useEffect } from "react"
import { getDefaultLogo } from "../utils/domain.utils"

interface UseCompanyInfoReturn {
  domainID: string
  domainName: string
  logo: string | null
  isLogoLoading: boolean
}

export const useCompanyInfo = (): UseCompanyInfoReturn => {
  const [domainID] = useState<string>("")
  const [domainName] = useState<string>("")
  const [logo, setLogo] = useState<string | null>(null)
  const [isLogoLoading, setIsLogoLoading] = useState(true)

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        // Set default logo
        setLogo(getDefaultLogo())
        // Customize this function according to your backend API
        // Example: Fetch domain/company info from API
        // const response = await authApi.getDomain(subdomain)
        // if (response?.id) {
        //   setDomainID(response.id)
        // }
        // if (response?.name) {
        //   setDomainName(response.name)
        // }
        // setLogo(formatLogoUrl(response?.logo))
      } catch (error) {
        console.error("Error fetching company info:", error)
        setLogo(getDefaultLogo())
      } finally {
        setIsLogoLoading(false)
      }
    }

    fetchCompanyInfo()
  }, [])

  return {
    domainID,
    domainName,
    logo,
    isLogoLoading,
  }
}
